import React from 'react';
import classNames from 'classnames';

import { LockedIcon, UnlockedIcon } from "../../assets/icons";

import './styles.scss';

type ProgressBarProps = {
  withLock?: boolean,
  isUnlocked?: boolean;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({
  withLock = false,
  isUnlocked,
}) => {
  return (
    <div className={classNames("ProgressBar", {
      "withLock": withLock,
    })}>
      {withLock && (
        <div className={classNames("TopicStatus", {
          "isLocked": !isUnlocked,
        })}>
          {isUnlocked ? <UnlockedIcon className={"UnlockedIcon"}/> : <LockedIcon className={"LockedIcon"}/>}
        </div>
      )}
      {(!withLock || (withLock && isUnlocked)) && (<div className={"ProgressIndicators"}>
        <div className={"Indicator Completed"}/>
        <div className={"Indicator InProgress"}/>
        <div className={"Indicator Incomplete"}/>
      </div>
      )}
    </div>
  )
};
